import React from "react";
import "./Homepage.css";

import Banner from "../components/Banner/banner_homepage";
import AboutSection from "../components/AboutSection/aboutus_homepage";
import ProductsSection from "../components/ProductsSection/production_homepage";
import PromotionSection from "../components/PromotionSection/promotion_homepage";
import ContactSection from "../components/Contact/contact_homepage";

const Homepage = () => {
    return (
        <div className="homepage">
            <section id="home">
                <Banner />
            </section>
            
            <section id="about">
                <AboutSection />
            </section>
            
            <section id="products-section">
                <ProductsSection />
            </section>
            
            <section id="promotions-section">
                <PromotionSection />
            </section>
            
            <section id="contact">
                <ContactSection />
            </section>
        </div>
    );
};

export default Homepage;